import _ from 'lodash';

export const computePricing = (
  msrp,
  incentives,
  selections,
  country,
  brand
) => {
  const { engine } = selections;
  const getLuxuryTaxVal = netPrice =>
    msrp.flt && msrp.flt.above < netPrice
      ? (netPrice - msrp.flt.above) * msrp.flt.taxRate
      : 0;

  // Check if the engine is an electric vehicle (EV)
  const isEV = engine === 'EN0'; //EN0 = Engine None, because EV don't have an engine, they have a motor
  let totalMsrp = msrp.employeePrice ? msrp.employeePrice : msrp.totalMsrp;
  const isEVDiscountEligible =
    (brand === 'chevrolet' || brand === 'gmc') && country === 'US';
  const evDiscount =
    isEV && isEVDiscountEligible ? msrp.totalMsrpWithOptions * 0.003 : 0;
  totalMsrp = totalMsrp - evDiscount;
  const eventDiscount = msrp.isConfidencePrice
    ? totalMsrp - msrp.supplierPrice
    : 0;
  const incentiveDiscount = incentives.total
    ? incentives.total
    : incentives.value;
  const totalDiscountWithoutPacakge = incentiveDiscount + eventDiscount;
  const netPrice = msrp.totalMsrp - totalDiscountWithoutPacakge;
  const employeePriceDifference = msrp.employeePrice
    ? msrp.totalMsrp - totalMsrp
    : 0;
  const totalDiscount =
    totalDiscountWithoutPacakge + msrp.opdTotal + evDiscount;
  const totalEmployeeDiscount = employeePriceDifference
    ? totalDiscount + employeePriceDifference
    : 0;
  const netEmployeePrice = totalMsrp - totalDiscountWithoutPacakge;
  const luxuryTaxNetPrice = netPrice + getLuxuryTaxVal(netPrice);
  const luxuryTaxNetEmployeePrice =
    netEmployeePrice + getLuxuryTaxVal(netEmployeePrice);

  return _.assign({}, msrp, {
    incentives: incentives,
    isSeeDealer: !msrp.isActualPrice,
    eventDiscount: eventDiscount,
    totalDiscount: totalDiscount,
    netPrice: luxuryTaxNetPrice,
    netEmployeePrice: luxuryTaxNetEmployeePrice,
    employeePriceDifference: employeePriceDifference,
    totalEmployeeDiscount: totalEmployeeDiscount,
    luxuryTax: {
      val: getLuxuryTaxVal(netPrice),
      employeeVal: getLuxuryTaxVal(netEmployeePrice),
      label: msrp.flt && msrp.flt.label
    }
  });
};
